<template>
  <v-dialog v-model="dialog" width="500" :key="refresh">
    <template v-slot:activator="{ on }">
      <v-btn :color="color" :class="{ 'pl-1 ml-4': !!icon }" v-on="on">
        <v-icon v-if="!!icon" class="ml-1" left>{{ icon }}</v-icon>
        {{ title }}
      </v-btn>
    </template>
    <v-card class="ma-0 pa-0">
      <v-textarea class="ma-0 pa-0"
                  placeholder="Paste rows and columns here..."
                  @input="submit"
                  v-model="pastedContent"
                  hide-details autofocus solo></v-textarea>
    </v-card>
  </v-dialog>
</template>

<script>
import { Bus } from '../bus'

export default {
  name: 'PasteMultiple',
  props: {
    /**
     * Text that is displayed on the button
     */
    title: {
      type: String,
      default: 'Multiple'
    },
    /**
     * The icon to be displayed on the button, if empty no icon will be displayed
     */
    icon: {
      type: String,
      default: 'people'
    },
    /**
     * The parser function that will be called on the pasted text (if none, the pasted text will be sent as is)
     */
    parser: {
      type: Function,
      default: x => x
    },
    color: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      pastedContent: '',
      refresh: 0
    }
  },
  methods: {
    submit () {
      try {
        const parsedText = this.parser(this.pastedContent)
        this.pastedContent = ''
        this.dialog = false
        this.refresh++
        this.$emit('paste', parsedText)
      } catch (err) {
        Bus.$emit('alert', { color: 'error', message: err.toString() })
      }
    }
  }
}
</script>
